import { RouteObject } from 'react-router';
import React, { Suspense } from 'react';
import PageSkeleton from '@/modules/ui/skeleton/PageSkeleton';

const LoginPage = React.lazy(() => import('@/modules/auth/pages/LoginPage'));
const SignupPage = React.lazy(() => import('@/modules/auth/pages/SignupPage'));
const ForgotPasswordPage = React.lazy(() => import('@/modules/auth/pages/ForgotPasswordPage'));

export const authChildren: RouteObject[] = [
  {
    path: 'login',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: 'signup',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <SignupPage />
      </Suspense>
    ),
  },
  {
    path: 'forgot-password',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <ForgotPasswordPage />
      </Suspense>
    ),
  },
];
